import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';
import { CalendarResponse } from '../types';
import { getClassroomCalendar } from '../../api';
import { AxiosResultDefaultError } from '../../../../../api/request';

export interface ClassroomCalendarLoaderProps<T> {
  classroomId: number | string;
  children: (props: { data: T }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  CalendarResponse,
  AxiosResultDefaultError
>();

export const useClassroomCalendar = useFetch;

export const ClassroomCalendarConsumer = FetchConsumer;

export function ClassroomCalendarLoader({
  classroomId,
  children,
}: ClassroomCalendarLoaderProps<CalendarResponse>) {
  const request = useCallback(() => {
    return getClassroomCalendar(classroomId);
  }, [classroomId]);
  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          const lastActivityId =
            data.activities[data.activities.length - 1]?.id || 0;
          data.activities.push({
            id: lastActivityId + 1,
            name: 'Evento',
          });

          return children({ data });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
